// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDQpt6CkBCQAQfPpW7lLtUueYUZo_0rv9g",
  authDomain: "abiu-135d5.firebaseapp.com",
  databaseURL: "https://abiu-135d5-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "abiu-135d5",
  storageBucket: "abiu-135d5.appspot.com",
  messagingSenderId: "234932429863",
  appId: "1:234932429863:web:6c247468d1270db1b75a02",
  measurementId: "G-VFRMHQGH7K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, googleProvider, db, storage }; 